import { getEmailBasePath } from './basePath'

/** Known email-hub folder routes — anything else under the mount is a detail id. */
const EMAIL_FOLDER_SEGMENTS = new Set([
  'inbox',
  'starred',
  'sent',
  'archived',
  'trash',
  'drafts',
  'compose',
  'contacts',
  'settings',
  'tags-rules',
])

/**
 * True for `<base>/<uuid>` full-page reader routes.
 *
 * Base-path aware: the host mount prefix (`/emails` on master,
 * `/email` on SAM, `` on the standalone hub) is stripped before we
 * test the next segment, so a detail route resolves on every host.
 */
export function isEmailDetailPathname(pathname: string): boolean {
  const parts = pathname.split('/').filter(Boolean)
  const baseParts = getEmailBasePath().split('/').filter(Boolean)
  // The path must start with the configured base segments.
  for (let i = 0; i < baseParts.length; i += 1) {
    if (parts[i] !== baseParts[i]) return false
  }
  const seg = parts[baseParts.length]
  if (!seg) return false
  return !EMAIL_FOLDER_SEGMENTS.has(seg)
}
